import { useFormContext } from 'react-hook-form';

import { useStepContext } from '~/app/providers/paymentStepProvider';
import { generateGradient } from '~/shared/lib/generateGradient';
import { Halo } from '~/shared/ui/Halo/Halo.ui';
import { Header } from '~/shared/ui/Header/Header';
import { IconImage } from '~/shared/ui/IconLogo/IconLogo.ui';

import { SteamPage } from '../../../../features/Steam';
import { FormType } from '../../../PayPage.scheme';
import { Logo } from '../../Logo/Logo';
import { CERTIFICATES_CONFIG } from '../SelectCertificateStep/constants/certificates';

import { HeaderWrapper, Main, Root } from './SteamStep.ui';

export const SteamStep = ({ isLoading }: { isLoading: boolean }) => {
  const { goBack } = useStepContext();
  const { getValues } = useFormContext<FormType>();
  const currentCertificate = getValues('certificate');
  const { color, name, brand } = currentCertificate || {};

  const certificateData = CERTIFICATES_CONFIG[brand?.slug || ''];

  return (
    <Root>
      <HeaderWrapper>
        <Header
          leftIconSlot={
            certificateData?.logoUrl ? (
              <IconImage
                alt={name}
                loading="lazy"
                size={24}
                src={certificateData.logoUrl}
              />
            ) : (
              <Logo name={name || ''} />
            )
          }
          onClick={goBack}
          title={name || ''}
          type="back"
        />
      </HeaderWrapper>
      <Halo
        aria-hidden="true"
        gradient={color && generateGradient(color)}
        top={300}
      />
      <Main>
        <SteamPage isLoading={isLoading} />
      </Main>
    </Root>
  );
};
